module.exports = __webpack_public_path__ + "img/produit-details-black.b773aca8.svg";